import React, { createContext, useContext, useState } from 'react';

const MobileFilterContext = createContext();

export const MobileFilterProvider = ({ children }) => {
  const [isMobileFilterOpen, setIsMobileFilterOpen] = useState(false);

  const toggleMobileFilter = () => {
    setIsMobileFilterOpen(prev => !prev);
  };

  const closeMobileFilter = () => {
    setIsMobileFilterOpen(false);
  };

  const openMobileFilter = () => {
    setIsMobileFilterOpen(true);
  };

  return (
    <MobileFilterContext.Provider value={{
      isMobileFilterOpen,
      setIsMobileFilterOpen,
      toggleMobileFilter,
      closeMobileFilter,
      openMobileFilter,
    }}>
      {children}
    </MobileFilterContext.Provider>
  );
};

export const useMobileFilter = () => {
  const context = useContext(MobileFilterContext);
  if (!context) {
    throw new Error('useMobileFilter must be used within MobileFilterProvider');
  }
  return context;
};
